<template>
  <div>
    <div class="main-title">学员录入
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" size="small" @click="openAddDialog">录入学员</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择考场"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索驾校/教练/学员/身份证/拼音"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属考场"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="170">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="create_user_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">备注</el-button>
            <el-button type="text" style="color: red;" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增学员表单对话框 -->
    <el-dialog title="录入学员" :visible.sync="addDialogVisible" width="500px">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <el-form-item label="所属考场" prop="company_id">
          <el-select v-model="addForm.company_id" placeholder="请选择考场" style="width:100%">
            <el-option
              v-for="item in companyList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学员姓名" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入学员姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="addForm.idcard" placeholder="请输入身份证号">
            <el-button slot="append" @click="readIdcard" :loading="idcardReading">读身份证</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="驾校/教练" prop="coach_id">
          <el-col :span="18">
            <el-select
              v-model="addForm.coach_id"
              filterable
              remote
              reserve-keyword
              placeholder="输入教练姓名或拼音"
              :remote-method="searchCoach"
              :loading="coachLoading">
              <el-option
                v-for="item in coachList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button type="text" @click="addCoach">添加新教练</el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="安全员" prop="secu_id">
          <el-select
            v-model="addForm.secu_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入安全员姓名或拼音"
            :remote-method="searchSecu"
            :loading="secuLoading">
            <el-option
              v-for="item in secuListFilter"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddForm" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import BatchSearch from './BatchSearch'
import moment from 'moment'
import _ from 'lodash'
export default {
  mixins: [ListFunc, DatePickerOptions],
  props: {
    user: Object
  },
  components: {
    BatchSearch
  },
  data () {
    return {
      sqlcode: "student_hjd",
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        datefield: 'daterange',
        daterange: [
          moment().subtract(3, 'month').startOf('month').toDate(),
          new Date()
        ]
      },
      commiting: false,
      finItemList: [],
      accountList: [],
      feePackageList: [],
      addDialogVisible: false,
      addForm: {
        name: '',
        idcard: '',
        company_id: '',
        coach_id: 0,
        secu_id: 0,
        remark: ''
      },
      addFormRules: {
        name: [
          { required: true, message: '请输入学员姓名', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        company_id: [
          { required: true, message: '请选择所属考场', trigger: 'change' }
        ],
        coach_id: [
          { required: true, message: '请选择教练', trigger: 'change' }
        ]
      },
      submitting: false,
      idcardReading: false,
      coachList: [],
      coachLoading: false,
      secuList: [],
      secuLoading: false
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          idcard_guid: this.searchForm.idcard_guid,
        }
      } else {
        let params = {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          idcard_guid: this.searchForm.idcard_guid,
        }
        params[this.searchForm.datefield + '_start'] = moment(this.searchForm.daterange[0]).format('YYYY-MM-DD')
        params[this.searchForm.datefield + '_end'] = moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        return params
      }
    },
    secuListFilter () {
      return this.secuList.filter(r => (r.company_id === 0 || r.company_id === this.addForm.company_id))
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchSecuList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    fetchSecuList () {
      this.$http.get(`/dbapi/secu_combo`).then(response => {
        if (response.data.success) {
          this.secuList = response.data.list
        }
      })
    },
    searchCoach: _.debounce( // 搜索教练
      function (query) {
        this.coachLoading = true
        this.$http.get('/dbapi/coach_combo?query=' + query).then(response => {
          this.coachLoading = false
          if (response.data.success) {
            this.coachList = response.data.list
          }
        })
      },
      500
    ),
    searchSecu: _.debounce( // 搜索安全员
      function (query) {
        this.secuLoading = true
        this.$http.get(`/dbapi/secu_combo?company_id=${this.addForm.company_id}&query=${query}`).then(response => {
          this.secuLoading = false
          if (response.data.success) {
            this.secuList = response.data.list
          }
        })
      },
      500
    ),
    batSearch (guid) { // 批量搜索
      this.searchForm.idcard_guid = guid
      this.search(this.searchParams)
    },
    edit (row) {
      this.$prompt(`请输入备注`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/student_remark_hjd', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_student_hjd', { id: row.id }).then(res => {
          if (res.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: "error",
              message: "网络错误，请稍后重试"
            })
            console.log(res)
          }
        })
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
      this.addForm = {
        name: '',
        idcard: '',
        company_id: this.companyList.length > 0 ? this.companyList[0].value : '',
        coach_id: 0,
        secu_id: 0,
        remark: ''
      }
      this.coachList = []
      this.secuList = []
      this.fetchSecuList()
      this.readIdcard()
    },
    readIdcard () {
      if (!this.idcardReading) {
        this.idcardReading = true
        this.$idcard.read().then(data => {
          this.idcardReading = false
          this.addForm.name = data.name
          this.addForm.idcard = data.code
        }).catch((e) => {
          this.idcardReading = false
          this.$message({
            type: 'warning',
            message: '读取身份证失败，请手动填写信息'
          })
        })
      }
    },
    submitAddForm () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.submitting = true
          // 提交前将选中的教练和安全员转为名称
          let coachObj = this.coachList.find(c => c.value === this.addForm.coach_id)
          let secuObj = this.secuList.find(s => s.value === this.addForm.secu_id)
          
          let submitData = {
            ...this.addForm,
            coach_name: coachObj ? coachObj.label : '',
            secu_name: secuObj ? secuObj.label : ''
          }
          
          this.$http.post('/dbapi/add_student_hjd', submitData).then(response => {
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '学员添加成功'
              })
              this.addDialogVisible = false
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
            this.submitting = false
          })
        } else {
          return false
        }
      })
    },
    addCoach () {
      this.$router.push('/coach/new')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/rent/StudentHJD.vue